import { FormRow as FormRowCore, IFormRowProps as IFormRowPropsCore } from "@webbio/components";

import styles from "./form-row.module.scss";

const FormRow = (props: IFormRowPropsCore): JSX.Element => {
  return <FormRowCore {...props} propStyles={styles} />;
};

export { FormRow };
